<template>
  <Teleport to="#app">
    <div class="position-absolute d-lg-flex d-none p-3 justify-content-center align-items-center snackbar" :class="{open: isOpen}">
      <svg v-if="icon" width="12" height="12" class="me-2 d-none d-lg-inline-block" style="color:var(--color-agency)"><use :href="icon"></use></svg>
      <span>{{text}}</span>
      <svg @click="isOpen=false" role="button" width="12" height="12" class="ms-2 d-none d-lg-inline-block"><use href="/sprite.svg#close"></use></svg>
    </div>
    <div class="position-sticky d-lg-none d-flex p-3 justify-content-center align-items-center snackbar-mobile" :class="{openMobile: isOpen}">
      <svg v-if="icon" width="24" height="12" class="me-2 d-inline-block" style="color:var(--color-agency)"><use :href="icon"></use></svg>
      <span>{{text}}</span>
      <svg @click="isOpen=false" role="button" width="24" height="12" class="ms-2"><use href="/sprite.svg#close"></use></svg>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch, defineProps, onMounted } from 'vue'

const isOpen = ref(false)
const timeout = ref()
const isMounted = ref(false)
const activityTimestamp = ref(Date.now())

const props = defineProps(['text', 'open', 'icon','type'])

watch(() => props.open, o => {
  isOpen.value = o
})

watch(activityTimestamp, () => {
  toggleState(false)
})

const toggleState = (o) => {
  if(timeout.value){
    clearTimeout(timeout.value)
  }
  timeout.value= setTimeout(() => {
    if(isMounted.value){
      isOpen.value = !o
    }
  }, 60000)
}

onMounted(() => {
  isMounted.value=true;
  if(props.type ==='generic'){
    toggleState(isOpen.value)
  }

  if(props.type === 'inactivity'){
    toggleState(false)
    window.document.addEventListener('mousemove', () => {
      activityTimestamp.value = Date.now()
    })
    window.document.addEventListener('touchmove', () => {
      activityTimestamp.value = Date.now()
    })
  }
})

watch(isOpen, o => {
  if(o && props.autoClose){
  toggleState(!o)
  }
})
</script>

<style scoped>
.open{
  top:0 !important;
}
.snackbar{
  left:50%;
  top:-50% ;
  transform: translateX(-50%);
  transition: all 1s ease;
  box-shadow: 0 3px 6px 0px rgb(0 0 0 / 0.16);
  border-radius: 4px;
  background-color: var(--bs-body-bg);
}

.openMobile{
  transform: translateX(0%) !important;
}

.snackbar-mobile{
  bottom:0 !important;
  transition: all 1s ease;
  transform: translateX(-100%);
  box-shadow: 0 3px 6px 0px rgb(0 0 0 / 0.16);
  border-radius: 4px;
  background-color: var(--bs-body-bg);
}
</style>